// Anruf-Ergebnis → Fall und Vorlage der Post-Call-Mail (ADR 0368, Plan PR 2). Reine Funktionen: das
// Anruf-Fenster ruft sie nach dem Speichern auf, der Composer bekommt nur das Ergebnis.
import type { CallOutcome } from '../../../types';
import { saisonOffen } from './mailPruefer';
import { vorlagenFuerFall, type Fall } from './postCallVorlagen';

export interface FallWahl { fall: Fall; vorlageId: string }

/** Bis zu so vielen Tagen Wiedervorlage heißt „Interesse, Termin offen“ (Fall B), darüber „später“ (Fall E). */
export const SPAETER_AB_TAGEN = 14;

const TAG_MS = 86_400_000;

function parseIso(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const d = new Date(iso.endsWith('Z') || iso.includes('T') ? iso : iso.replace(' ', 'T') + 'Z');
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Welche Mail gehört zu diesem Gesprächsergebnis? `null` = keine (Sekretariat, nicht erreicht, …). */
export function fallFuerErgebnis(ergebnis: CallOutcome | null | undefined, wiedervorlageIso: string | null | undefined,
                                 jetzt: Date = new Date()): FallWahl | null {
  switch (ergebnis) {
    case 'TERMIN': return { fall: 'A', vorlageId: 'A1' };
    case 'MAIL GEWÜNSCHT': return { fall: 'C', vorlageId: 'C1' };
    case 'FALSCHER ANSPRECHPARTNER': return { fall: 'D', vorlageId: 'D1' };
    // Kein Interesse: die Tür offen halten (H2). „Ich melde mich nicht mehr“ (I1) schickt nur, wer es ausdrücklich will.
    case 'LOST': return { fall: 'H', vorlageId: 'H2' };
    case 'FOLLOW UP': {
      const d = parseIso(wiedervorlageIso);
      const tage = d ? (d.getTime() - jetzt.getTime()) / TAG_MS : 0;
      if (tage > SPAETER_AB_TAGEN) {
        // Später: mit Q4-Test, solange die Frist offen ist, sonst die schlichte Bestätigung.
        const v = vorlagenFuerFall('E', { saisonOffen: saisonOffen(jetzt), angerufen: true });
        return { fall: 'E', vorlageId: (v.find((x) => x.saison) ?? v[0]).id };
      }
      return { fall: 'B', vorlageId: 'B' };
    }
    default: return null;
  }
}

/** „Mittwoch, 4. November, 15 Uhr“ und kurz „Mittwoch, 15 Uhr“ für Betreff und Text von Fall A. */
export function terminTexte(iso: string | null | undefined): { lang: string; kurz: string } {
  const d = parseIso(iso);
  if (!d) return { lang: '', kurz: '' };
  const wochentag = d.toLocaleDateString('de-DE', { weekday: 'long' });
  const datum = d.toLocaleDateString('de-DE', { day: 'numeric', month: 'long' });
  const uhr = d.getMinutes() === 0 ? `${d.getHours()} Uhr`
    : `${d.getHours()}:${String(d.getMinutes()).padStart(2, '0')} Uhr`;
  return { lang: `${wochentag}, ${datum}, ${uhr}`, kurz: `${wochentag}, ${uhr}` };
}

/** „am 11. November“ für „ich melde mich …“ (Fälle E und H). */
export function wiedervorlageText(iso: string | null | undefined): string {
  const d = parseIso(iso);
  return d ? `am ${d.toLocaleDateString('de-DE', { day: 'numeric', month: 'long' })}` : '';
}
